
import { useStore } from "vuex"
import { defineComponent, watch, ref, computed } from "vue"
import GenericButton from "../GenericButton.vue";

const reqLevelCategories = ['Perks', 'SupportPerks', 'Implants', 'CombatImplants', 'MysteryBoosts'];
const implantCategories = ['Implants', 'CombatImplants'];

export default defineComponent({
  name: "DefaultContent",
  components: { GenericButton },
  setup() {
    const store = useStore()
    const infoPanelData = ref({ ...store.state.infoPanel });
    const show = computed(() => {
      const { bonuses, key, modifiedBy, modifies, notes, penalties, requirements, type, wiki } = infoPanelData.value;

      return {
        requiredLevel: reqLevelCategories.includes(type) && !!store.state.build[type][key].level,
        drugsDuration: type === 'Drugs' && key !== 'CharismaBoost',
        requirements: !!requirements.length,
        modifiedBy: !!modifiedBy.length,
        notes: notes && notes.length && !implantCategories.includes(type),
        modifies: !!modifies.length,
        bonuses: !!bonuses.length,
        penalties: !!penalties.length,
        implantRequirements: implantCategories.includes(type),
        implantNotes: notes && notes.length && implantCategories.includes(type),
        wikiButton: !!wiki
      }
    })
    const getImage = (type: string, image: string) => {
      let img;
      try {
        img = require(`@/assets/img/info-panel/${type}/${image}.png`);
      } catch (e) {
        img = require("@/assets/img/info-panel/Default/Info Panel.png");
      }
      return img;
    };
    watch(() => store.state.infoPanel, (to) => {
        infoPanelData.value = { ...to };
      }
    );
    return {
      state: store.state,
      infoPanelData,
      getImage,
      show
    }
  },
})
